/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aiflowdescriptiongerman3Inputs */

const en_aiflowdescriptiongerman3 = /** @type {(inputs: Aiflowdescriptiongerman3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`German`)
};

const de_aiflowdescriptiongerman3 = /** @type {(inputs: Aiflowdescriptiongerman3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deutsch`)
};

/**
* | output |
* | --- |
* | "German" |
*
* @param {Aiflowdescriptiongerman3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const aiflowdescriptiongerman3 = /** @type {((inputs?: Aiflowdescriptiongerman3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aiflowdescriptiongerman3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_aiflowdescriptiongerman3(inputs)
	return de_aiflowdescriptiongerman3(inputs)
});
export { aiflowdescriptiongerman3 as "aiFlowDescriptionGerman" }